import type { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { UpsellBlock, UpsellLandingPage } from 'generated/resources/datatable.graphql'

import { GlpButtonBlock } from 'modules/discover/components/LandingPageBlocks/GlpButtonBlock'

type UpsellGlpHeroSection = UpsellBlock['glpHeroSection']

interface GlpHeroSectionBlockProps {
  block: UpsellGlpHeroSection
  slug: string
  landingPage: UpsellLandingPage
  currentUpsellOrigin: {
    request_source: string
    request_source_category?: string
    request_source_component?: string
  } | null
}

export const GlpHeroSectionBlock: FC<GlpHeroSectionBlockProps> = ({
  block,
  slug,
  landingPage,
  currentUpsellOrigin,
}) => {
  if (!block) {
    return null
  }

  const videoId = block?.videoUrl?.split('v=')[1]?.split('&')[0]
  return (
    <Box className="mx-auto" alignItems="center" textAlign="center" gap="s16" maxWidth="s600">
      {block?.title && (
        <Text size="700" color="black" weight="bold">
          {block?.title || ''}
        </Text>
      )}
      {block?.subtitle && (
        <Text size="400" className="mb-4">
          {block?.subtitle || ''}
        </Text>
      )}

      <Box gap="s16" flexDirection="row" justifyContent="center">
        {block?.actions &&
          block?.actions?.map((action) => (
            <GlpButtonBlock
              key={action?.id}
              block={action}
              slug={slug}
              landingPage={landingPage}
              currentUpsellOrigin={currentUpsellOrigin}
            />
          ))}
      </Box>

      <Box
        paddingTop="s24"
        paddingBottom="s80"
        className="max-h-[450px] max-w-[800px]"
        position="relative"
      >
        {videoId ? (
          <iframe
            width="793px"
            height="446px"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`}
            allowFullScreen
            style={{
              borderRadius: '14px 14px 14px 14px',
            }}
          />
        ) : (
          <video
            src={block?.media?.url || ''}
            className="rounded-lg max-h-[450px]"
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              borderRadius: '8px',
              justifyContent: 'center',
            }}
            autoPlay
            muted
            loop
          />
        )}
      </Box>
    </Box>
  )
}
